import React, { useState } from 'react'
import { RemoveScroll } from 'react-remove-scroll'
import MenuContent from 'components/menu/menuContent'
import MenuButton from 'components/menu/menuButton'
import withRootContext from 'context/withRootContextHOC'
import WarningModal from 'src/components/warningModal'

import MODAL from 'src/utils/modals'

const Menu = ({ context: { toggleMenu, isMenuVisible, firstName, isReactNative, logoutUser } }) => {
  const [isLogoutModalVisible, setLogoutModalVisible] = useState(false)
  const { icon, title, body, cancelLabel, confirmLabel } = MODAL.LOGGOUT_MODAL()

  const handleLogout = async () => {
    setLogoutModalVisible(false)
    await logoutUser()
  }

  const handleLogoutModalToggle = () => setLogoutModalVisible(!isLogoutModalVisible)

  return (
    <>
      <MenuButton
        toggleMenu={toggleMenu}
        active={isMenuVisible}
      />
      <RemoveScroll
        noIsolation={false}
        enabled={isMenuVisible}
      >
        <MenuContent
          active={isMenuVisible}
          toggleMenu={toggleMenu}
          firstName={firstName}
          isReactNative={isReactNative}
          onLogout={handleLogoutModalToggle}
        />
      </RemoveScroll>
      {isLogoutModalVisible &&
        <WarningModal
          visible={isLogoutModalVisible}
          title={title}
          titleSize='16px'
          icon={icon}
          onCancel={handleLogoutModalToggle}
          onConfirm={handleLogout}
          confirmLabel={confirmLabel}
          cancelLabel={cancelLabel}
          dataTest='modal-warning-loggout'
          outlineCancelButton
        >
          {body}
        </WarningModal>}
    </>
  )
}

export default withRootContext(Menu)
